// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import { MaterialCard } from './components/material'

// Plugins
import './plugins/vuetify'
import Sticky from 'vue-sticky-directive'

// Application imports
import App from './App'
import router from '@/router'
import store from '@/store'

Vue.component('MaterialCard', MaterialCard)

Vue.config.productionTip = false
Vue.use(Sticky)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
